import { useLang } from "@/context/LanguageContext";

export const LanguageSwitch = ({ variant = "light" }) => {
  const { locale, setLocale } = useLang();
  const isDark = variant === "dark";
  const base = isDark ? "text-[var(--lab-cream)]/60" : "text-[var(--lab-ink)]/50";
  const active = isDark ? "text-[var(--lab-cream)]" : "text-[var(--lab-ink)]";

  return (
    <div className="flex items-center gap-2 font-mono-label" data-testid="lang-switch">
      <button
        onClick={() => setLocale("pt")}
        data-testid="lang-pt-btn"
        className={`transition-colors ${locale === "pt" ? active : base + " hover:" + active.replace("text-", "text-")}`}
      >
        PT
      </button>
      <span className={base}>/</span>
      <button
        onClick={() => setLocale("en")}
        data-testid="lang-en-btn"
        className={`transition-colors ${locale === "en" ? active : base}`}
      >
        EN
      </button>
    </div>
  );
};
